import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';
import React from 'react';
import { IoChevronForward } from 'react-icons/io5';

interface OpenIconProps {
  $isOpened: boolean;
  $canBeOpened: boolean;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

const OpenIconContainer = styled.span<OpenIconProps>`
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: ${p => (p.$canBeOpened ? 'initial' : 'lightgray')};

  transition: 0.3s all;
  transform: rotateZ(${p => (p.$isOpened ? 90 : 0)}deg);
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${p => (p.$canBeOpened ? COLORS.HOVER_GREY_LIGHT : 'initial')};
    color: ${p => (p.$canBeOpened ? p.theme.colors.primary : 'initial')};
  }
`;

export const OpenIcon: React.FC<OpenIconProps> = props => {
  return (
    <OpenIconContainer {...props}>
      <IoChevronForward />
    </OpenIconContainer>
  );
};
